module.exports = __webpack_public_path__ + "img/goal06_over.dafdd26d.png";